module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAfUlEQVR42u3aMQ3AMAwAQVOIFBVCQJVmeEQKn0ouCW++4Qnc/JGZ0bkAAAAAAAAAAAAAAKA5wNxvVvbdp7QzVmkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAJwCnKAAAAAAAAAAAAAAArfoBQizBSICyyBsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Mali.png
// module id = i1Z1
// module chunks = 0 62 63